module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/lion-portuguese.5d05bd1e.jpg";